import { SuggestionVisibility as e } from "../../../../types/components/select.js";
const S = (i, s) => i.some((o) => o.options.some((t) => t.label === s)), c = ({
  searchValue: i,
  sections: s,
  suggestionProps: o
}) => {
  const t = S(s, i), n = o?.suggestionVisibility, g = n === e.ALWAYS_VISIBLE, u = n === e.VISIBLE_WHEN_TYPED;
  return {
    isSuggestionVisible: !!(g || u && i && !t)
  };
};
export {
  c as useSuggestion
};
